// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a0Xr","title":"styles_title__10Dlm"};